import React from 'react';
import { Document, Page, Text, View, StyleSheet } from '@react-pdf/renderer';

const styles = StyleSheet.create({
  page: {
    padding: 24,
    fontSize: 9,
    fontFamily: 'Helvetica',
    color: '#111537',
    backgroundColor: '#ffffff',
  },
  headerContainer: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    paddingBottom: 14,
    borderBottomWidth: 2,
    borderBottomColor: '#048178',
    marginBottom: 16,
  },
  companyTitle: {
    fontSize: 16,
    fontWeight: 'bold',
    color: '#048178',
  },
  reportTitle: {
    fontSize: 12,
    fontWeight: 'bold',
    color: '#111537',
    marginTop: 2,
  },
  metaText: {
    fontSize: 8,
    color: '#606279',
    textAlign: 'right',
  },
  table: {
    display: 'table',
    width: 'auto',
    borderStyle: 'solid',
    borderWidth: 1,
    borderColor: '#e2e8f0',
    borderRadius: 4,
    overflow: 'hidden',
  },
  tableRowHeader: {
    flexDirection: 'row',
    backgroundColor: '#048178',
    alignItems: 'center',
    paddingVertical: 6,
    paddingHorizontal: 4,
  },
  tableHeaderCell: {
    color: '#ffffff',
    fontWeight: 'bold',
    fontSize: 8.5,
  },
  tableRow: {
    flexDirection: 'row',
    borderBottomWidth: 1,
    borderBottomColor: '#f1f5f9',
    alignItems: 'center',
    paddingVertical: 6,
    paddingHorizontal: 4,
    minHeight: 24,
  },
  tableRowEven: {
    backgroundColor: '#f8fafc',
  },
  tableCell: {
    fontSize: 8,
    color: '#334155',
  },
  colSno: { width: '8%', textAlign: 'center' },
  colProduct: { width: '34%', paddingRight: 6 },
  colCategory: { width: '18%', paddingRight: 4 },
  colUnit: { width: '10%', textAlign: 'center' },
  colAlternate: { width: '30%', paddingLeft: 4 },
  alternateBadge: {
    color: '#048178',
    fontWeight: 'bold',
  },
  noAlternateText: {
    color: '#94a3b8',
    fontStyle: 'italic',
  },
  footer: {
    position: 'absolute',
    bottom: 16,
    left: 24,
    right: 24,
    flexDirection: 'row',
    justifyContent: 'space-between',
    fontSize: 7.5,
    color: '#94a3b8',
    borderTopWidth: 1,
    borderTopColor: '#e2e8f0',
    paddingTop: 6,
  },
});

const DownloadMaterialVsAlternatePDF = ({ data = [], date = new Date().toLocaleDateString() }) => {
  return (
    <Document>
      <Page size="A4" orientation="portrait" style={styles.page}>
        {/* Header */}
        <View style={styles.headerContainer}>
          <View>
            <Text style={styles.companyTitle}>NuTrade Procurement</Text>
            <Text style={styles.reportTitle}>Material Requested vs Alternate Report</Text>
          </View>
          <View>
            <Text style={styles.metaText}>Generated On: {date}</Text>
            <Text style={styles.metaText}>Total Items: {data.length}</Text>
          </View>
        </View>

        {/* Table */}
        <View style={styles.table}>
          <View style={styles.tableRowHeader}>
            <Text style={[styles.tableHeaderCell, styles.colSno]}>S.No</Text>
            <Text style={[styles.tableHeaderCell, styles.colProduct]}>Product (Material Requested)</Text>
            <Text style={[styles.tableHeaderCell, styles.colCategory]}>Category</Text>
            <Text style={[styles.tableHeaderCell, styles.colUnit]}>Unit</Text>
            <Text style={[styles.tableHeaderCell, styles.colAlternate]}>Alternate Product</Text>
          </View>

          {data && data.length > 0 ? (
            data.map((item, index) => (
              <View
                key={index}
                style={[styles.tableRow, index % 2 === 1 ? styles.tableRowEven : {}]}
              >
                <Text style={[styles.tableCell, styles.colSno]}>{item?.sno || index + 1}</Text>
                <View style={[styles.colProduct]}>
                  <Text style={[styles.tableCell, { fontWeight: 'bold' }]}>
                    {item?.product_name || item?.product || item?.name || '-'}
                  </Text>
                  {item?.product_code && (
                    <Text style={{ fontSize: 7, color: '#64748b', marginTop: 1 }}>
                      Code: {item.product_code}
                    </Text>
                  )}
                </View>
                <Text style={[styles.tableCell, styles.colCategory]}>
                  {item?.category_name || item?.category || '-'}
                </Text>
                <Text style={[styles.tableCell, styles.colUnit]}>
                  {item?.product_unit || item?.unit || '-'}
                </Text>
                <View style={[styles.colAlternate]}>
                  {item?.alternate_product || item?.alternateProduct || item?.alternate_name ? (
                    <View>
                      <Text style={[styles.tableCell, styles.alternateBadge]}>
                        {item?.alternate_product || item?.alternateProduct || item?.alternate_name}
                      </Text>
                      {item?.alternate_notes && (
                        <Text style={{ fontSize: 7, color: '#64748b', marginTop: 1 }}>
                          Note: {item.alternate_notes}
                        </Text>
                      )}
                    </View>
                  ) : (
                    <Text style={[styles.tableCell, styles.noAlternateText]}>No alternate assigned</Text>
                  )}
                </View>
              </View>
            ))
          ) : (
            <View style={[styles.tableRow, { justifyContent: 'center', paddingVertical: 14 }]}>
              <Text style={[styles.tableCell, { color: '#94a3b8' }]}>No records available</Text>
            </View>
          )}
        </View>

        {/* Footer */}
        <View style={styles.footer} fixed>
          <Text>Confidential - NuTrade Procurement System</Text>
          <Text
            render={({ pageNumber, totalPages }) =>
              `Page ${pageNumber} of ${totalPages}`
            }
          />
        </View>
      </Page>
    </Document>
  );
};

export default DownloadMaterialVsAlternatePDF;
